import React, {useEffect} from 'react';
import {Col, Row} from 'antd';
import { useTranslation } from 'react-i18next';

// Components and Subcomponents
import ButtonComponent from '../subComponents/ButtonComponent';
import TitleComponent from '../subComponents/TitleComponent';

// Assets
import logo from '../../assets/DKT_Lockup_Primary_Blue_RGB.png';

// Constants and Functions
import {routes} from '../../utils/routes';
import {getWindowInformation, redirectWindow} from '../../utils/generalUtils';

// Store
import {useAppDispatch} from "../../store/store";
import {decryptTempToken} from "../../store/redux/actions/sessionActions";


const Login = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const { pathname, search } = getWindowInformation();

    if(pathname === routes(t).session.authentication){
      const urlParams = new URLSearchParams(search);
      const code = urlParams.get('c') ?? '';

      dispatch(decryptTempToken(code));
    }
  }, []);

  const handleLogin = () => {
    redirectWindow(routes(t).session.oauth);
  };

  return (
    <Row className={'session-container flex min-h-screen bg-grey-dkt-100 bg-no-repeat bg-cover'}
         style={{ backgroundImage: 'url(\'https://idpdecathlon.oxylane.com/assets/images/3.jpg\')' }}>
      <Col className={'sm:mx-auto sm:w-full sm:max-w-md m-auto bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'}>
        <Col md={24}>
          <img src={logo} alt={''} />
        </Col>
        <Col md={24}>
          <TitleComponent level={2} text={t('login')}
                          className={'my-8 text-center text-grey-dkt-400'} />
        </Col>
        <Col md={24}>
          <ButtonComponent text={t('loginDecathlonAccount')}
                           className={'w-full p-2 text-white bg-orange-dkt-400 hover:bg-orange-dkt-500 focus:outline-none ' +
                             'focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-300 '
                           }
                           onClick={handleLogin}
          />
        </Col>
      </Col>
    </Row>
  );
}

export default Login;